<template>
  <div class="login">
    <div class="login__wrapper">
      <img src="../assets/img/icon.png" alt="icon Iivaara Wilderness Lodge">
      <h1>Log in</h1>
      <div class="contact__form">
        <form action="" @submit.prevent="login">
          <label for="username">Gebruiker</label>
          <input type="text" id="username" class="input" v-model="user.username" @input="error=''">
          <label for="userpass">Paswoord</label>
          <input type="password" id="userpass" class="input" v-model="user.password" @input="error=''">
          <button class="button" :class="{'button--disabled':!user.username||!user.password}">Log in</button>
          <p v-if="error" class="error">{{ error }}</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login.vue",

  data() {
    return {
      user: {
        username: "",
        password: ""
      },
      error: ""
    }
  },

  created(){
    if(localStorage.getItem('LoggedUser')){
      this.$router.push('/dashboard');
    }
  },

  methods: {
    login() {
      if (this.user.username === process.env.VUE_APP_LOGIN_USER && this.user.password === process.env.VUE_APP_LOGIN_PASSWORD) {
        localStorage.setItem('LoggedUser', this.user.username);
        this.$router.push('/dashboard');
        return;
      }
      this.error = "Ongeldige login-gegevens."
    }
  }
}
</script>
